import {Component, OnDestroy} from '@angular/core';
import {DialogAdapter, DialogParams, DialogResult} from '../../models/dialog-param';
import {BUTTON_NAME, EMAIL_REGEX} from '../../common/constants';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GroupSetting} from '../../models/group-setting';
import {GroupService} from '../../services/group.service';
import {SharedValueService} from '../../services/shared-value.service';
import {Subscription} from 'rxjs/Rx';
import {Helper} from '../../common/helper';

@Component({
  selector: 'app-modal-user',
  templateUrl: './modal-user.component.html',
  styleUrls: ['./modal-user.component.scss'],
  preserveWhitespaces: false
})
export class ModalUserComponent implements DialogAdapter, OnDestroy {
  params: DialogParams;
  prop: any;
  formGroup: FormGroup;
  isInitial = true;
  groups: GroupSetting[] = [];
  messageError: any;
  formError = {
    name: '',
    email: '',
    password: '',
    confirm_password: ''
  };
  subscription: Subscription;
  groupSubscription: Subscription;


  constructor(private fb: FormBuilder,
              private groupService: GroupService,
              private sharedValueService: SharedValueService,
              private helper: Helper) {
    this.helper._unsubsribe(this.groupSubscription);
    this.helper._unsubsribe(this.subscription);
    this.groupSubscription = this.groupService.getAllGroups().subscribe(gr => {
      this.groups = gr;
    });
    this.subscription = sharedValueService.getHttpStatus().subscribe(status => {
      if (status) {
        if (this.prop && this.prop.hasOwnProperty('isAPICallError')) {
          this.prop.isAPICallError = false;
        }
        this.formGroup.reset();
        this.params.subject.complete();
        setTimeout(() => {
          (<any>$('#theModal')).modal('hide');
          this.isInitial = true;
          this.helper._unsubsribe(this.subscription);
        });
      } else {
        if (this.prop) {
          this.prop.isAPICallError = true;
          this.prop.checkValidate = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.groupSubscription);
    this.helper._unsubsribe(this.subscription);
  }

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
    if (this.isInitial) {
      this.formGroup = this.createForm(this.prop);

      this.messageError = this.getValidationMessages();

      this.isInitial = false;
    } else {
      if (this.checkValidate()) {
        this.prop.checkValidate = false;
        this.params.subject.next(new DialogResult(BUTTON_NAME.OK, this.getPayload()));
      } else {
        this.prop.checkValidate = true;
      }
    }
  }

  createForm(data: any) {
    const form = this.fb.group({
      'email': [
        data.model.email, Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX)])
      ],
    });
    if (data.isAdd || data.isEdit) {
      form.addControl('name', new FormControl(data.model.name,
        Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(255)])));
      form.addControl('group_id', new FormControl(data.model.group_id));
      data.model.group_id ? form.controls['group_id'].setValue(data.model.group_id, {onlySelf: true}) :
        form.controls['group_id'].setValue(null, {onlySelf: true});
    }
    if (data.isAdd || data.isRestore) {
      form.addControl('password', new FormControl('',
        Validators.compose([Validators.required, Validators.minLength(6)])));
      form.addControl('confirm_password', new FormControl('', Validators.required));
    }
    return form;
  }


  checkValidate() {
    let checkSpace = false;
    let passIsMatch = true;
    for (const field in this.formError) {
      this.formError[field] = '';
      const control = this.formGroup.get(field);
      if (field === 'name' && control && control.value && control.value.trim() === '') {
        this.formError[field] = this.messageError[field]['required'];
        checkSpace = true;
      }
      if (field === 'confirm_password' && control && control.value !== this.formGroup.get('password').value) {
        this.formError[field] = this.messageError[field].pattern;
        passIsMatch = false;
      }
      if (control && control.invalid) {
        for (const key in control.errors) {
          const mess = this.messageError[field];
          if (control.errors.hasOwnProperty(key)) {
            this.formError[field] = mess[key];
          }
        }
      }
    }
    return this.formGroup.valid && !checkSpace && passIsMatch;
  }

  onChangeGroup(groupId: number) {
    this.formGroup.controls['group_id'].setValue(groupId);
  }


  getValidationMessages() {
    return {
      'name': {
        'required': 'Fullname is required.',
        'minlength': 'Fullname must be at least 4 characters in length.',
        'maxlength': 'Fullname must be less than 255 characters in length.'
      },
      'email': {
        'required': 'Email is required.',
        'pattern': 'Email is invalid.'
      },
      'password': {
        'required': 'Password is required.',
        'minlength': 'Passwords must be at least 6 characters in length.'
      },
      'confirm_password': {
        'required': 'The confirm password is required',
        'pattern': 'Passwords do not match.'
      },
      'group_id': {
        'required': 'Group is required.'
      }
    };
  }

  getPayload() {
    return {
      isAPICallError: this.prop.isAPICallError,
      checkValidate: this.prop.checkValidate,
      model: this.formGroup.value
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal-user/modal-user.component.ts